// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let LocationV1Api = class LocationV1Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Gets All States.
     */
    async getAllStates() {
        const _url_ = '/location/v1/State';
        let _params_ = {};
        let _headers_ = {};
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationSharedStateModels");
        }
        return response;
    }
    /**
     *
     * @summary Gets a list of City records related to the specified Zip code
     * @param zipCode
     */
    async getCitiesByZip(zipCode) {
        const _url_ = '/location/v1/City';
        let _params_ = {};
        let _headers_ = {};
        if (zipCode !== undefined) {
            _params_['zipCode'] = Serializer.serialize(zipCode, "string");
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationCityModels");
        }
        return response;
    }
    /**
     *
     * @summary Gets a Private City related to the specified Zip code
     * @param zipCode
     */
    async getPrimaryCityByZip(zipCode) {
        const _url_ = '/location/v1/PrimaryCity';
        let _params_ = {};
        let _headers_ = {};
        if (zipCode !== undefined) {
            _params_['zipCode'] = Serializer.serialize(zipCode, "string");
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationCityModels");
        }
        return response;
    }
    /**
     *
     * @summary Validate an address
     * @param LocationAddressModel The address to validate
     */
    async validAddress(LocationAddressModel) {
        const _url_ = '/location/v1/ValidAddress';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'LocationAddressModel' is not null or undefined
        if (LocationAddressModel === null || LocationAddressModel === undefined) {
            throw new Error('Required parameter LocationAddressModel was null or undefined when calling validAddress.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(LocationAddressModel, "LocationAddressModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationValidAddressModelResponse");
        }
        return response;
    }
};
LocationV1Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], LocationV1Api);
export { LocationV1Api };
//# sourceMappingURL=locationV1Api.js.map